// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Lottie from 'lottie-react';

import config from 'config';

import Selectable from 'components/focus/Selectable';
import Image from 'components/common/Image';

import Ref from 'models/propTypes/ref';

import styles from './CircleTile.module.scss';

const brand = config.buildBrandId;

const CircleTile = ({
  title,
  focusId,
  className,
  onFocusSet,
  staticImageSrc,
  staticActiveImage,
  lottieImageSrc,
  domRef,
  onClick,
}) => {
  const [lottieAnim, setLottieAnim] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (brand === 'cbs-sports' && lottieImageSrc) {
      const getJSON = async () => {
        await fetch(lottieImageSrc, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(responseData => {
            if (isMounted) {
              setLottieAnim(responseData);
            }
          });
      };

      getJSON();
    }
    return () => {
      isMounted = false;
    };
  }, [lottieImageSrc]);

  const lottieRef = useRef();

  const [inFocus, setInFocus] = useState(false);

  useEffect(() => {
    if (brand === 'cbs-sports') {
      if (!lottieRef.current) return;

      if (inFocus) {
        lottieRef.current.play();
      } else {
        lottieRef.current.stop();
      }
    }
  }, [inFocus, title]);

  return (
    <span
      ref={domRef}
      key={focusId}
      className={classNames('d-flex align-items-center')}
    >
      <Selectable
        onSelect={onClick}
        focusId={focusId}
        className={className}
        onFocusSet={onFocusSet}
        data-testid="media-tile"
        ttsText={title}
        render={({ hasFocus }) => {
          setTimeout(() => setInFocus(hasFocus));
          return (
            <div
              className={classNames(
                'position-relative',
                hasFocus ? styles.focused : styles.unfocused,
                lottieAnim ? styles.tileAnimated : styles.tile,
              )}
              style={{
                zIndex: hasFocus ? 1 : -1,
              }}
            >
              <button
                type="button"
                onClick={onClick}
                className={classNames('w-100 h-100', styles.button)}
              >
                <div
                  className={classNames(
                    'position-relative  align-items-center justify-content-center',
                  )}
                >
                  {!lottieAnim && (
                    <Image
                      alt="logo"
                      src={hasFocus ? staticActiveImage : staticImageSrc}
                      className={classNames(
                        styles.staticImage,
                        hasFocus ? styles.focused : styles.unfocused,
                      )}
                    />
                  )}
                  {lottieAnim && brand === 'cbs-sports' && (
                    <Lottie
                      lottieRef={lottieRef}
                      animationData={lottieAnim}
                      loop={false}
                      autoplay={hasFocus}
                    />
                  )}
                  <span className={styles.title}>
                    {' '}
                    {brand === 'cbs-sports' ? title : ''}
                  </span>
                </div>
              </button>
            </div>
          );
        }}
      />
    </span>
  );
};

CircleTile.propTypes = {
  title: PropTypes.string.isRequired,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onFocusSet: PropTypes.func,
  staticImageSrc: PropTypes.string,
  staticActiveImage: PropTypes.string,
  lottieImageSrc: PropTypes.string,
  domRef: Ref,
  onClick: PropTypes.func,
};

CircleTile.defaultProps = {
  focusId: null,
  className: null,
  onFocusSet: () => {},
  staticImageSrc: null,
  staticActiveImage: null,
  lottieImageSrc: null,
  domRef: null,
  onClick: () => {},
};

export default React.memo(
  React.forwardRef((props, ref) => <CircleTile {...props} domRef={ref} />),
);
